export const PICKER_WIDGETS_LOAD = 'PICKER_WIDGETS_LOAD';
export const PICKER_INFO_LOAD = 'PICKER_INFO_LOAD';
export const PICKER_SET_TEMPLATE = 'PICKER_SET_TEMPLATE';

import CATEGORIES from '../../../widgets/components/widgetCategories';

export const EDITOR = {
    TABS: {
        LAYOUT: 'layout',
        PARAMS: 'params',
        IMAGE_MANIPULATIONS: 'im',
    },
};

export const ALL_WIDGETS = [
    CATEGORIES.V2.TOURNAMENT_FIXTURES,
    CATEGORIES.V2.TOURNAMENT_TABLES,
    CATEGORIES.V2.MATCH_PRE,
    CATEGORIES.V2.MATCH_LIVE,

    CATEGORIES.V2.PLAYERS_STATS,
    CATEGORIES.V2.PLAYERS_H2H,

    CATEGORIES.V2.TEAMS,
    CATEGORIES.V2.TOP_LISTS,

    CATEGORIES.V2.TRANSFERS,

    CATEGORIES.V2.EDITORIAL,
    CATEGORIES.V2.ODDS,
    CATEGORIES.V2.BASEBALL,

    // CATEGORIES.V2.TOURNAMENT,
    // CATEGORIES.V2.TEAMS,
    // CATEGORIES.V2.TEAMS_H2H,

    // CATEGORIES.V2.PLAYERS,
];

export const TABS = {};
TABS.ALL = 'all';
TABS.LEAGUE = 'league';
TABS.PLAYER = 'player';
TABS.TEAM = 'team';
TABS.EVENT = 'event';
TABS.PORTFOLIO = 'portfolio';
TABS.INTERESTS = 'interests';

export const GROUP_KEY = 'spec.v2Categories';



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/constants.js
 **/